@if ((isTrial$ | async) || upgraded) {
  <div class="mx-auto mb-6 max-w-xl">
    <app-card>
      @if (!upgraded) {
        <h2 class="text-base font-semibold text-fg">Word lid</h2>
        <p class="mt-1 text-sm text-fg-muted">
          Heb je een chipnummer of code gekregen? Vul het hier in om onbeperkt
          te reserveren.
        </p>
        <div class="mt-4 flex flex-col gap-2 sm:flex-row">
          <!-- One field, so Enter has to work: this is not inside a <form>, and without
               this the Go key on a phone keyboard does nothing at all. -->
          <input
            appInput
            [formControl]="chipnumber"
            type="text"
            placeholder="Chipnummer of code"
            (keydown.enter)="upgrade()"
          />
          <button
            appButton
            type="button"
            class="shrink-0"
            [disabled]="chipnumber.invalid || inSubmission"
            (click)="upgrade()"
          >
            Lid worden
          </button>
        </div>
      }
      @if (showAlert) {
        <div class="mt-3">
          <app-alert [severity]="severity" [message]="message" />
        </div>
      }
    </app-card>
  </div>
}
